import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { DashboardView } from "@containers/dashboard/DashboardView";

const SignaturesPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="signatures">
            <DashboardView />
        </AuthenticatedLayout>
    );
}

export default SignaturesPage;
